// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Vetting40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Vetting40Filled: FC<Vetting40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path
                d="M16.288 4.895c1.864-2.458 5.56-2.458 7.423 0a4.658 4.658 0 0 0 4.346 1.8c3.056-.42 5.668 2.192 5.248 5.248a4.658 4.658 0 0 0 1.8 4.346c2.459 1.863 2.459 5.559 0 7.423a4.658 4.658 0 0 0-1.8 4.345c.42 3.056-2.192 5.668-5.248 5.248a4.658 4.658 0 0 0-4.346 1.801c-1.863 2.458-5.559 2.458-7.423 0a4.658 4.658 0 0 0-4.345-1.8c-3.056.42-5.668-2.193-5.248-5.249a4.658 4.658 0 0 0-1.8-4.345c-2.458-1.864-2.458-5.56 0-7.423a4.658 4.658 0 0 0 1.8-4.346c-.42-3.056 2.192-5.668 5.248-5.248a4.658 4.658 0 0 0 4.345-1.8Zm1.934 16.8-3.833-3.917-2.056 2.027 5.889 5.862 9.444-9.389-2.027-1.944-7.417 7.361Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Vetting40Filled;
